/*
 * @Author:
 * @Date: 2023-12-14 13:32:44
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-10 16:29:00
 * @Description: 这是用户的登录注册与退出的接口
 * 在 mini 版中没有调用这些接口，其实 
 */

import { usePublicApi } from '../base';

export const useUpload = () => {
    const publicApi = usePublicApi('', {
        headers:{
            'Content-Type': 'multipart/form-data',
        },
    });
    // ↓ 上传文件接口
    // 当时为了上传头像开发的接口，后来被废弃了，因为不应该开放自定义头像功能（防止用户在头像上打广告）
    const UPLOAD_FILE = async (
        data: {file: File},
    ) => {
        const oData = new FormData();
        oData.append('file', data.file); 
        const response = await publicApi.post(
            '/v1/upload',
            oData,
        );
        return response?.data;
    };

    return {
        UPLOAD_FILE,
    };
};



